import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
//import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { SvgIconComponent } from './app-jt-svg-icon';
import { CustomTranslateLoader } from '../../../_services/app-customtranslation.loader';


@NgModule({
  declarations: [
    SvgIconComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  //  ModalModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    SvgIconComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SvgIconModule { }
